import React, { Component } from "react";

import Card from "./Card";
import { connect } from "react-redux";
import { loadTopPosts } from "../actions";
import { watchLoadTopPostsRequests } from "../sagas";
import { connectSaga } from "../../../util/hoc/connectSaga";
class CardsWrapper extends Component {
  state = {
    posts: [],
  };
  componentDidMount() {
    const numOfCases = 3;
    this.props.actions.loadTopPosts(numOfCases);
  }
  render() {
    return (
      <section className="content-wrapper">
        {this.props.posts.map((post, index) => <Card post={post} key={index} />)}
      </section>
    );
  }
}

const mapStateToProps = state => ({
  posts: state.posts.topPosts,
});

const mapDispatchToProps = dispatch => ({
  actions: {
    loadTopPosts: count => dispatch(loadTopPosts(count)),
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(connectSaga(CardsWrapper, watchLoadTopPostsRequests));



// WEBPACK FOOTER //
// ./src/scenes/LandingPage/components/CardsWrapper.js